export class DeviceCameraUtilitiesService {
  public static async isDeviceCameraAvailable(): Promise<boolean> {
    const mediaDevices = (await navigator.mediaDevices.enumerateDevices()) ?? [];

    return mediaDevices.some((device) => device.kind === 'videoinput');
  }
}
